import { render, staticRenderFns } from "./bomprocesslist.vue?vue&type=template&id=a6530b14&scoped=true&"
import script from "./bomprocesslist.vue?vue&type=script&lang=js&"
export * from "./bomprocesslist.vue?vue&type=script&lang=js&"
import style0 from "./bomprocesslist.vue?vue&type=style&index=0&id=a6530b14&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6530b14",
  null
  
)

export default component.exports